import moment from "moment";

export const formatFeedbackTags = (feedbackString) => {
  if (!feedbackString) return [];
  try {
    return feedbackString
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  } catch (error) {
    console.error("Error formatting feedback tags:", error);
    return [];
  }
};

export const formatDate = (date) => {
  if (!date) return "Unknown date";
  try {
    return moment(date).format("DD MMM YYYY");
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid date";
  }
};

export const formatDateWithTime = (date) => {
  if (!date) return "Unknown date";
  try {
    return moment(date).format("DD MMM YYYY [at] hh:mm A");
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid date";
  }
};
// export const formatDate = (dateString) => {
//   if (!dateString) return "Unknown date";
//   try {
//     // Ensure the date string is properly formatted for UTC
//     let date;
//     if (dateString.includes("T")) {
//       // If it's an ISO string format
//       date = new Date(dateString);
//     } else {
//       // Try to parse as UTC date
//       date = new Date(dateString + "T00:00:00Z");
//     }

//     if (isNaN(date.getTime())) {
//       console.error("Invalid date parsing result for:", dateString);
//       return "Invalid date";
//     }

//     const formatted = new Intl.DateTimeFormat("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     }).format(date);

//     return formatted;
//   } catch (error) {
//     console.error(
//       "Error formatting date:",
//       error,
//       "for date string:",
//       dateString
//     );
//     return "Invalid date";
//   }
// };
